import './styles/error-pages.scss'

import $ from 'jquery'
import 'bootstrap'
import lottie from 'lottie-web'

global.lottie = lottie
global.$ = $